import { usePageInfo } from '../config/queries'
import { useActionable } from './useActionable'
import { useCustomDomain } from './useCustomDomain'
import { useHasSidebar } from './useHasSidebar'

export const useStickyTop = () => {
  const {
    data: { user },
  } = usePageInfo()
  const { customDomain } = useCustomDomain()
  const hasSidebar = useHasSidebar()
  const { currentAction } = useActionable(user)

  if (customDomain) {
    if (hasSidebar) {
      if (currentAction) {
        // actionbar (32px)
        return 'top-[32px]'
      }

      return 'top-0'
    }

    if (currentAction) {
      // Top navigation (56px) + actionbar (32px) - negative margin (1px)
      return 'top-[88px]'
    }

    // Top navigation (56px)
    return 'top-[56px]'
  }

  if (currentAction) {
    // Top navigation (56px) + subheader (38px) + actionbar (31px) + margin (3px)
    return 'top-[128px]'
  }

  // Top navigation (56px) + subheader (38px) + margin (3px)
  return 'top-[97px]'
}
